exports = module.exports = require("../../../web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2GtLD6i9vSUCrUHOfuJMQ5{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-ms-flex-direction:row;flex-direction:row;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.YJIu-79alxCm0AuJhIeuH{margin:0;margin-right:1rem}\n", ""]);

// exports
exports.locals = {
	"colButtonEdit": "_2GtLD6i9vSUCrUHOfuJMQ5",
	"text": "YJIu-79alxCm0AuJhIeuH"
};